// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pg-service-order-tracking-common":"3f67a59dc4e8b82b8f57","OrderTracking":"a06401fe1819dfd776e5","OrderTrackingInformation":"c3eb8b752afbd4e32425","OrderStatusInfo":"af8625f72441f5901542"}[chunkId] + ".bundle.js";
};